import CoursePrivateLearningCoachingForm from '@/views/App/Course/PrivateLearningCoaching/Form.vue';
import CoursePrivateLearningCoachingList from '@/views/App/Course/PrivateLearningCoaching/List.vue';

const routesCoursePrivateLeaningCoaching = [
    {
        path: 'list',
        name: 'coursePrivateLearningCoachingList',
        component: CoursePrivateLearningCoachingList
    },
    {
        path: 'form/:id?',
        name: 'coursePrivateLearningCoachingForm',
        component: CoursePrivateLearningCoachingForm
    },
  ];

export default routesCoursePrivateLeaningCoaching;